export function formatISODate(iso: string | null | undefined): string {
  if (!iso) return '';
  return new Date(iso.slice(0, 10) + 'T12:00:00').toLocaleDateString('ru-RU', {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
  });
}

/** Детерминированная дата «дд.мм.гггг» из ISO, без зависимости от локали WebView. */
export function formatIsoDateDdMmYyyy(iso: string | null | undefined): string {
  if (!iso) return '';
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  if (!match) return '';
  return `${match[3]}.${match[2]}.${match[1]}`;
}

/** Короткая дата занятия для списков: «чт, 01.10». */
export function formatSlotDayShort(iso: string | null | undefined): string {
  if (!iso) return '';
  const d = new Date(iso.slice(0, 10) + 'T12:00:00');
  if (Number.isNaN(d.getTime())) return iso;
  const weekday = d.toLocaleDateString('ru-RU', { weekday: 'short' });
  const dayMonth = d.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit' });
  return `${weekday}, ${dayMonth}`;
}

/** Период для подписей: «30.09 — 14.10». */
export function formatDayRangeShort(fromIso: string, toIso: string): string {
  const fmt = (iso: string) => {
    const d = new Date(iso.slice(0, 10) + 'T12:00:00');
    return Number.isNaN(d.getTime()) ? iso : d.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit' });
  };
  return `${fmt(fromIso)} — ${fmt(toIso)}`;
}
